<script setup>
import { computed } from 'vue';
import { messageTimestamp } from 'shared/helpers/timeHelper';
import BaseBubble from './Base.vue';
import { useMessageContext } from '../provider.js';

const { content, createdAt, id, contentAttributes } = useMessageContext();

const isSeparator = computed(
  () => typeof id.value === 'string' && id.value.startsWith('separator-')
);

const readableTime = computed(() =>
  messageTimestamp(createdAt.value, 'LLL d, HH:mm')
);

// Para los separadores de conversación, formatear la fecha usando el timestamp de contentAttributes
const displayContent = computed(() => {
  if (isSeparator.value) {
    const timestamp = contentAttributes.value?.conversationCreatedAt;
    if (timestamp) {
      const formattedDate = messageTimestamp(timestamp, 'dd MMM yyyy HH:mm');
      return `${content.value} — ${formattedDate}`;
    }
  }
  return content.value;
});
</script>

<template>
  <BaseBubble
    v-tooltip.top="readableTime"
    class="px-3 py-1 !rounded-xl flex min-w-0 items-center gap-2"
    :class="{ 'bg-woot-500 text-white': isSeparator }"
    data-bubble-name="activity"
  >
    <span v-dompurify-html="displayContent" :title="displayContent" />
  </BaseBubble>
</template>
